export const fmtDate = (d, tz) => new Date(d).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", ...(tz ? { timeZone: tz } : {}) });

// Short label for the community's own timezone ("Central", "Pacific"…) so a manager in another
// timezone knows a scheduled 8am means 8am for the RESIDENTS.
export const tzLabel = (tz) => {
  if (!tz) return "";
  const short = (v) => v.replace(" Standard", "").replace(" Daylight", "").replace(" Time", "");
  try {
    const name = new Intl.DateTimeFormat([], { timeZone: tz, timeZoneName: "long" })
      .formatToParts(new Date()).find((p) => p.type === "timeZoneName")?.value;
    return name ? short(name) : tz.split("/")[1]?.replace(/_/g, " ") || tz;
  } catch { return tz.split("/")[1]?.replace(/_/g, " ") || tz; }
};

// UTC ISO → "YYYY-MM-DDTHH:MM" on the community's clock, for a datetime-local input.
export const toLocalInput = (iso, tz) => {
  if (!iso) return "";
  try {
    const parts = new Intl.DateTimeFormat("en-CA", { ...(tz ? { timeZone: tz } : {}), year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false })
      .formatToParts(new Date(iso));
    const g = (t) => parts.find((p) => p.type === t)?.value;
    return `${g("year")}-${g("month")}-${g("day")}T${g("hour") === "24" ? "00" : g("hour")}:${g("minute")}`;
  } catch { return ""; }
};

export const minLocalInput = () => {
  const d = new Date(Date.now() + 60000);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};


// Optional expiry-time choices for announcements — community-local wall clock. "" = end of day.
export const EXPIRE_TIMES = [["", "End of day (11:59 PM)"], ["07:00", "7:00 AM"], ["08:00", "8:00 AM"], ["09:00", "9:00 AM"],
  ["12:00", "Noon"], ["17:00", "5:00 PM"], ["18:00", "6:00 PM"], ["19:00", "7:00 PM"], ["20:00", "8:00 PM"], ["21:00", "9:00 PM"]];

// Human "stops at" preview: the entered date + (time or 11:59 PM), labelled with the community tz.
export const expiryPreview = (dateStr, timeStr, tz) => {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-").map(Number);
  const [hh, mm] = (timeStr || "23:59").split(":").map(Number);
  const dt = new Date(y, (m || 1) - 1, d || 1, hh, mm);
  const dstr = dt.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric", year: "numeric" });
  const tstr = dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  const zone = tzLabel(tz);
  return `${dstr} · ${tstr}${zone ? " " + zone : ""}`;
};
